import type { SuggestedDraftsStoreSchema, SuggestedDraftsStoreEntry, } from "./schema/SuggestedDraftsStore";
import { createStore } from "owa-satcheljs";

export const getSuggestedDraftsStore: () => SuggestedDraftsStoreSchema = createStore<SuggestedDraftsStoreSchema>("suggestedDrafts", {
    suggestedDraftsMap: new Map<string, SuggestedDraftsStoreEntry>(),
});
